// src/utils/apiSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { toast } from "react-toastify";
import { logout } from "./authSlice";
import SERVICE_BASE_URLS from "./apiConfig";

// Base query with token
const dynamicBaseQuery = fetchBaseQuery({
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.token;
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: async (args, api, extraOptions) => {
    // Parse args (string or object)
    let url = "";
    let service = "employee"; // default service
    let method = "GET";
    let body;

    if (typeof args === "string") {
      url = args;
    } else if (typeof args === "object") {
      url = args.url;
      service = args.service || service;
      method = args.method || method;
      body = args.body;
    }

    // Call API
    const result = await dynamicBaseQuery(
      {
        url: `${SERVICE_BASE_URLS[service]}${url}`,
        method,
        body,
      },
      api,
      extraOptions
    );

    // Global error handling
    if (result?.error) {
      const { status, data } = result.error;

      if (status === 401) {

        api.dispatch(logout());
        toast.error(data.message);

      } else if (data?.detail) {

        toast.error(data.detail);
      }
    }

    return result;
  },
  tagTypes: ["Items"],
  endpoints: (builder) => ({
    // GET Requests
    getallergies: builder.query({
      query: () => ({ url: "allergies", service: "common" }),
      providesTags: ["Allergies"],
    }),
    getChronicDeasese: builder.query({
      query: () => ({ url: "chronic-diseases", service: "common" }),
      providesTags: ["ChronicDiseases"],
    }),

    // POST Requests
    login: builder.mutation({
      query: (data) => ({
        url: "login",
        service: "auth",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["login"],
    }),
    register: builder.mutation({
      query: (data) => ({
        url: "signup",
        service: "auth",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["signup"],
    }),
    chatbot: builder.mutation({
      query: (data) => ({
        url: "chat",
        service: "dsApis",
        method: "POST",
        body: data,
      }),
      providesTags: ["chat"],
    }),


  }),

});

// Export hooks
export const {
  useGetallergiesQuery,
  useGetChronicDeaseseQuery,
  useLoginMutation,
  useRegisterMutation,
  useChatbotMutation

} = apiSlice;
